import { render, staticRenderFns } from "./ProfitReport.vue?vue&type=template&id=4c745852&"
import script from "./ProfitReport.vue?vue&type=script&lang=js&"
export * from "./ProfitReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports